import React from 'react'

function DatabaseIcon () {
  return (
    <div>
      <svg
        version='1.1'
        viewBox='0 0 1200 1200'
        width='300'
        height='300'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          transform='translate(583,23)'
          d='m0 0h62l46 1 94 4 22 1 31 3 31 5 18 5 5 1 19 5 45 7 12 1 19 5 13 6v2l3-1v2l6 2 7 3 22 7 12 3 5 4 5 3 1 3 5 5v2l5 1 5 3 7 2 4 3 5 11 3 18 1 1 1 18v150l-1 32-2 26-1 10-2 18-2 7-7 5-6 3-5 1-1 5-2 3h-2l2 10 5 7 5 3 1 3h3l1 3 2 1 8 24 3 20v24l1 9-1 18 1 20-1 21 1 29v38l-1 53-2 22-2 9-5 11-1 4h-2v3h-2l-2 4-5 8-5 4h-2v16l4 1 9 6 5 5 3 4 3 8 3 15 2 16v193l-4 37-3 12-5 8-8 6-9 4-5 5-4 5-4 1-1 3-17 6-16 4-16 6-9 6-15 6-21 4-29 4-20 3-12 3-11 3-7 2-16 4-17 3-26 3-11 1-29 1-11 1-52 1-35 2-27 1-28 1-2-1-6 1h-17l-6-2-1 2-9-1-5 1-27-1h-27l-5-1-26-2-54-2h-26l-26-1-24-2-28-4-18-4-23-6-22-4-2-1-13-1-16-3-24-5-16-5-6-3v-2l-7-2-4-2-11-4-9-2-8-3-8-2-11-4-7-7v-2h-2l-2-4-7-4-8-2-4-5-4-11-2-19v-153l-1-40-1-31 3-26 2-8h2l2-6 8-3 7-3 4-1-3-2 1-4h3l-2-5v-6l3-3-7-1-3-4v-2h-2v-2h-7l-1-3h-2l-1-6-1-17h-2l-2-3-1-6 1-23 1-53v-49l-1-19v-105l2-9h2l1-19 1-3 9-5 8-4 2-10h5l-1-8-6-1-2-1v-2l-4-2-5 1-2-1 1-4-6-1-2-27h-1l-1-39v-48l-1-58-1-12-1-27v-9l-1-4v-20l2-25 3-16 3-6 4-4 11-4h3v-2h3v-2l3-3 5-6h2l1-3 8-4 16-5 12-3 21-9 10-5 21-6 33-5 11-1 8-2 15-3 17-5 23-5 15-3 26-3 55-3 35-1 47-2zm-474 327m0 3m13 53m3 1 4 1z'
          fill='#2458A3'
        />
        <path
          transform='translate(1075,164)'
          d='m0 0 8 1 2 2 1 22v207l-2 5-10 4-13 5h-2l-2 4-1 17h2v3h-2l-1 3-11 7-38 19-19 5-22 3-26 5-16 5-20 7-21 4-10 1-15 1-10 1-18 1-47 2-40 3-38 4-32 2-23 2-26 1-5 1h-36l-29-2-18-1-17-1-21-2-35-3-14-1-18-2-11-1-41-1-10-1h-15l-11-2-28-2-18-5-16-6-23-7-15-3-30-4-12-3-19-10-18-8-10-3-12-10-3-1 1-8 3-2-1-2-2-1v-4l5-2 1-2-9-2-13-3-10-1-2-1v-175l1-61 9-1 7 3 10 7 6 3v2h4v2l5 1 13 4 6 1v2l8 1 14 8 13 5 7 3 7 1 25 4 2 1 18 2 26 6 8 1 9 3 26 8 11 1 5 1 16 2 78 3 5 1h55l7 1h14l13 1 41 1h56l17-1h17l16-1 36-1 38-1h12l7-1 42-2 23-2 21-3 21-5 11-3 8-3 10-2 7-2 17-3 16-2 7-2 20-3h3v-2l10-3 3-2 9-3 7-4 11-4 10-4 13-5 12-7 3-1v-2l8-6z'
          fill='#153E71'
        />
        <path
          transform='translate(1075,506)'
          d='m0 0 7 1 4 7v60l-1 154-5 9h-2v2h-2l-2 5-3 1-2 5-5 5h-2v3l-4 1-1 8-3 1 1 8-7 5-2 5-11 6-18 5-18 4-17 6-13 6-18 6-38 5-34 3-29 5-23 5-12 3-18 3-33 3-20 2-40 1h-48l-26 1h-55l-44-1h-56l-20-1-30-3-15-1-30-5-18-4-15-4-16-3-18-2-20-2-24-3-18-3-13-4-21-10-40-10-13-4-8-5-9-11-4-4v-2l-5-1v-4h3l1-3h-3l-2-4-2 2-2-3v-3h-2l-3-3-5-1v-6-2l-5-1-1-2-5-1-1-10v-215h7l5-1 12 3 3 2 6 2 12 8 12 6 2 2 13 4 20 4 16 4 17 5 11 5 6 2 16 5 10 1 9 2 23 2 21 1 10 2 19 2 12 1 18 3 21 4 17 3 20 4 32 4 21 1 10 1 43 1h85l2-1h42l6-1h2l31-2 10-2 21-2 27-5 5-2 19-2 7-2 30-4 17-1 13-2 23-2 26-3 16-3 26-10 13-4 15-4 21-5 12-4 12-6 17-10 15-9z'
          fill='#153E71'
        />
        <path
          transform='translate(1077,843)'
          d='m0 0 7 3 1 1 1 10v204l-2 16-3 5-13 6-8 4-3 3h-2v2l-11 8-5 3-16 4-22 5-13 4-22 11-5 2-30 5-21 2-12 1-16 2-21 3-10 3-9 2-10 3-14 4-17 3-26 2-31 1-14 1-46 1h-208l-67-3-3-1-18-2-18-4-9-4-19-4v-2h-8l-10-2-12-1-17-2-37-4-24-5-12-5-13-6-9-3-10-3-14-3-4-2-10-2-9-3-10-5-3-7-6-4-13-4-5-1-3-7-1-3-1-22v-205l11-1 5 2 3 2v2l4 1 10 7 10 5 8 2 9 2 12 4 16 8 11 5 14 4 9 1 9 2 26 3 24 4 25 6 10 4 24 6 23 3 38 2h17l22 1h29l25 1 40 2h73l14 1 4-1 7 1 14-1h11l6-1 34-2h11l7-1h63l9-1 16-1 17-1 17-3 11-2 18-5 24-7 33-6 27-3 22-5 13-5 12-7 20-7 11-4 9-3 9-5 8-7 8-6z'
          fill='#153E71'
        />
        <path
          transform='translate(550,35)'
          d='m0 0h71l105 1 58 2 14 2 13 3 20 7 7 3 21 4h11l9 2 49 3 10 1 20 4 9 4 10 6 3 1v2l10 2 4 2 16 3h7l4 2 8 1 12 5 10 6 5 5 2 1v2l4 1 6 3 5 2 7 1 3 2 1 4v44l-9-1-8 5-4 2v2l-13 8-11 5-12 4-9 4-7 3-8 4-6 2-7 3h-5v2l-16 3h-7l-1 2-18 2-14 3-13 2-5 2-13 3-5 2-23 6-12 2-14 2-24 2-25 1-19 1-5 1h-17l-36 1-38 1-10 1h-18l-25 1h-55l-39-1-12-1h-14l-3-1h-55l-10-1-26-1-46-2-18-2-12-2-16-4-16-5-6-2-11-2-23-5-17-2-9-2-20-3-18-6-14-7-7-4-8-2v-2l-9-1-15-5v-2h-4v-2l-4-1-11-7-4-3-6-1h-7v61h-1l-2-61 4-1v-34l2-13 2-4 17-2 6-3 7-6h2l2-4 4-4 11-5 21-4 15-2 15-4 4-1v-2l7-4h2v-2l7-4 13-4 23-2 23-1 13-1 7-1 26-3 5-2 12-2 13-4 5-3 14-3 7-2 21-3 33-1 24-1z'
          fill='#2458A3'
        />
        <path
          transform='translate(140,768)'
          d='m0 0h3l7 8 8 10 8 4 22 6 5 1 24 6 23 11 21 5 18 2 16 2 18 2 24 3 23 5 16 4 23 4 11 2 36 3 15 1 22 1h60l33 1h64l26-1h50l28-1 15-1 17-2 28-3 21-4 16-4 32-6 26-3 23-2 29-4 18-6 16-7 21-7 19-4 13-4 6-4h2l1-5 5-4 2-1 1-5h2l1 5-4 10v3l9 3 21 6 3 16 1 25v7l3 2v172l-1 10v22l-2 23-3 8-6 5-11 6-7 5-5 5-10 7-15 5-15 3-12 4-13 5-9 5-10 4-20 4-23 3-10 1-9 1-8 2-10 1-13 3-9 3-10 2-21 5-11 2-20 2-34 2-44 1-93 1h-8l-6 1h-10l-8-1-15 1-5-1-18-1-146-1-24-2-23-2-21-4-7-1-16-4-7-2-16-3-9-2-12-1-2-1-24-3-23-4-20-6-11-5-7-3-4-3-10-2-6-2-14-3-21-7-4-5-3-1-2-4v-3l-7-2-4-2-7-1-4-4-2-7-1-22 2-4 1 22 3 10 10 1 10 4 6 5 1 6 5 2 13 4 5 2 9 2 6 2 11 2 9 3 11 4 16 8 14 4 16 3 40 4 22 3 7 1 15 2v2l10 1 15 4 3 2 24 5 12 1 3 1 67 3h208l46-1 14-1 31-1 26-2 17-3 14-4 10-3 9-2 10-3 21-3 22-3h8l19-2 19-3 13-3 12-5 9-5 13-5 16-4 20-4 10-4 10-8h2v-2l10-7 12-5 4-1 3-9 1-16v-200l-1-10-7-3-5 2-13 10-5 4-10 5-11 3-17 6-9 4-11 6-16 6-19 4-27 3-33 6-28 8-18 5-21 3-8 1-24 2h-8l-6 1h-63l-7 1-27 1-17 1-7 1h-17l-8 1-7-1-4 1-20-1h-70l-21-1-15-1-34-1h-27l-23-1h-14l-20-1-23-2-23-4-18-6-21-6-22-4-28-4-13-1-12-3-8-1-9-3-16-8-11-5-19-6-8-1-12-6-11-8-3-1v-2l-4-2-7-1h-8v-27l1-23 3-3h2v-2l10-1 10-4h4l-1-3-8-1-1-3h7l-2-6 2-5 3 1 1-2z'
          fill='#2458A3'
        />
        <path
          transform='translate(583,23)'
          d='m0 0h62l46 1 94 4 22 1 31 3 31 5 18 5 5 1 19 5 45 7 12 1 19 5 13 6v2l3-1v2l6 2 7 3 22 7 12 3 5 4 5 3 1 3 5 5v2l5 1 5 3 7 2 4 3 5 11 3 18 1 1 1 18v150l-1 32-2 26-1 10-2 18-2 7-7 5-6 3-5 1-1 5-2 3h-2l2 10 5 7 5 3 1 3h3l1 3 2 1 8 24 3 20v24l1 9-1 18 1 20-1 21 1 29v38l-1 53-2 22-2 9-5 11-1 4h-2v3h-2l-2 4-5 8-5 4h-2v16l4 1 9 6 5 5 3 4 3 8 3 15 2 16v193l-4 37-3 12-5 8-8 6-9 4-5 5-4 5-4 1-1 3-17 6-16 4-16 6-9 6-15 6-21 4-29 4-20 3-12 3-11 3-7 2-16 4-17 3-26 3-11 1-29 1-11 1-52 1-35 2-27 1-28 1-2-1-6 1h-17l-6-2-1 2-9-1-5 1-27-1h-27l-5-1-26-2-54-2h-26l-26-1-24-2-28-4-18-4-23-6-22-4-2-1-13-1-16-3-24-5-16-5-6-3v-2l-7-2-4-2-11-4-9-2-8-3-8-2-11-4-7-7v-2h-2l-2-4-7-4-8-2-4-5-4-11-2-19v-153l-1-40-1-31 3-26 2-8h2l2-6h4v2l-4 1-1 25-1 243 1 15 2 7 3 2v2h7l9 4 2 1 2 4v3l4 1 3 4 21 7 14 3 16 4 5 4 13 5 11 4 13 4 23 4 24 3 2 1 12 1 25 5 7 2 16 4 10 2 27 4 14 1 24 2 146 1 20 1 4 1 17-1 7 1h9l11-1h21l82-1 39-1 34-2 22-3 24-5 6-2 9-2 26-6 7-1 9-1 5-1 10-1 30-4 19-5 12-6 13-6 11-3 10-3 10-2 14-5 9-7 3-1 2-4 9-6 11-6 4-6 2-13 1-14v-23l1-17v-164l-3-2v-17l-2-22-2-9-4-3-16-5-1-4-5-1 2-5v-10h2l1-4 7-8 2-1 1-3 3-1 8-13 5-14 1-18 1-33v-160l1-3-4-1v-32l-3-14-5-10-3-1-2-5h-2v-2h-3l-2-5-5-5v-7l-1-2v-14l9-6 15-6 2-7 1-29v-11l1-16v-26l1-62v-83l-3-2v-24l-2-21-2-7-10-2-5-2v-2l-5-1-4-3v-2l-3-1-4-5-5-3h-2v-2l-9-2-21-5-15-3-7-2v-2l-5-1-7-5-17-7-21-4-45-4-23-3-21-5-17-5-9-2-13-3-3-1-40-3h-26l-94-2h-120l-86 2-27 1-29 3-20 3-24 7-25 5-1 1-41 5-23 2-23 4-4 2h-4l-1 3-19 9-12 4-17 3-16 4-10 5-6 5-6 7-6 4-6 2-8 1-4 4-1 3-1 12v34l-2 1 1 38v189h-1l-1-18h-1l-1-39v-48l-1-58-1-12-1-27v-9l-1-4v-20l2-25 3-16 3-6 4-4 11-4h3v-2h3v-2l3-3 5-6h2l1-3 8-4 16-5 12-3 21-9 10-5 21-6 33-5 11-1 8-2 15-3 17-5 23-5 15-3 26-3 55-3 35-1 47-2z'
          fill='#7492B9'
        />
        <path
          transform='translate(532,31)'
          d='m0 0h121l93 2h27l39 3 3 1 13 3 16 4 26 7 15 2 13 2 45 4 21 4 17 7 9 6 3 1v2l7 1 36 8 9 3v2h2l1-2v3l5 2v2l3 1 4 5 8 4v2l11 2 4 2 3 7 2 21v24l3 2v84l-1 75v13l-1 16v14l-1 25-2 7-5 3-11 4-8 5v14l1 6 1 4 1 3 3 1 1 5h3v2h2l3 5 5 5 4 9 2 11v28l-1 4 4 1v164l-1 40-2 14-6 14-7 10h-3l-1 4-5 5-3 1-2 6-1 1v9l-2 4 4 2 1 3 18 6 2 3-13-3-11-3-5-3-1-4 4-9v-5h-3v-3l2-1 2-8 4-1v-3l6-5 3-5 4-4 1-2h2v-2l3-3 3-6 1-154v-60l-2-36-3-9-5-5-10-7-4-5-5-15 2-6h-2l-1-8 1-9 5-5 22-8 2-5v-207l-1-22-1-49-12-3-7-3-6-3v-2l-5-2-2-4-6-2-8-5-8-3-11-2-2-1-11-1-14-3-8-3-3-1v-2l-5-1-9-6-12-4-21-4h-10l-30-2-14-1-12-2h-9l-20-4-10-4-17-6-13-3-14-2-58-2-114-1h-62l-83 1-23 1-26 1-25 4-14 4-6 2-10 4-7 2-9 1-5 2-27 3-19 2-39 2-10 2-10 3-5 3h-2v2l-7 4h-2v2l-11 4-32 6-12 2-11 5h-2l-2 4-5 5-2 3-5 3-5 2-17 2-2 6-1 10-1 34-2-3v-31l1-12 3-6 3-2 11-2 6-3 7-6 5-5 6-5 11-4 21-5 11-2 14-5 14-7 1-2 8-3 23-4 32-3 32-4 1-1 16-3 16-4 9-3 20-4 37-4 69-2z'
          fill='#4F77AD'
        />
        <path
          transform='translate(230,976)'
          d='m0 0h20l12 3 8 4 6 7 4 11 2 6v25l-5 15-7 10-5 5-5 3-7 2h-26l-10-5-7-7v-2l-3-1-7-8-5-6v-2h-2l-3-6-1-4v-13l6-12 10-13 8-6 9-4z'
          fill='#D4B34E'
        />
        <path
          transform='translate(230,631)'
          d='m0 0h13l15 5 9 6 10 11 4 9 1 5v17l-2 13-5 10-4 6-5 2v2l-3 2h-3v2l-13 4-11 1-9-1-11-6-3-3-2-1v-2l-5-2v-2l-6-2-7-7-3-9-1-5v-14l2-7 9-10 11-8 12-12z'
          fill='#706F4C'
        />
        <path
          transform='translate(228,296)'
          d='m0 0h25l13 4 10 9 5 15 1 12-1 17-2 8-6 12-7 8-8 3-6 1h-25l-10-4-9-7-7-8-3-3-4-7-5-10-1-8 2-8 5-9 13-15 8-6 8-3z'
          fill='#D4B34E'
        />
        <path
          transform='translate(1083,798)'
          d='m0 0 2 4 2 12 1 25v7l3 2v172l-1 10v22l-2 23-3 8-6 5-11 6-7 5-5 5-10 7-15 5-15 3-12 4-13 5-9 5-10 4-20 4-23 3-10 1-9 1-8 2-10 1-13 3-9 3-10 2-21 5-11 2-20 2-34 2-44 1-93 1h-8l-6 1h-10l-8-1-15 1-5-1-18-1-146-1-24-2-23-2-21-4-7-1-16-4-7-2-16-3-9-2-12-1-2-1-24-3-23-4-20-6-11-5-7-3-4-3-10-2-6-2-14-3-21-7-4-5-3-1-2-4v-3l-7-2-4-2-7-1-4-4-2-7-1-22 2-4 1 22 3 10 10 1 10 4 6 5 1 6 5 2 13 4 5 2 9 2 6 2 11 2 9 3 11 4 16 8 14 4 16 3 40 4 22 3 7 1 15 2v2l10 1 15 4 3 2 24 5 12 1 3 1 67 3h208l46-1 14-1 31-1 26-2 17-3 14-4 10-3 9-2 10-3 21-3 22-3h8l19-2 19-3 13-3 12-5 9-5 13-5 16-4 20-4 10-4 10-8h2v-2l10-7 12-5 4-1 3-9 1-16v-200l-1-10z'
          fill='#4F77AD'
        />
        <path
          transform='translate(552,27)'
          d='m0 0h93l105 2 39 2 32 2 17 3 13 2 10 2 15 4 14 4 12 2 5 1 14 2 32 4 15 3 8 1 15 6 6 4 5 1v3l10 3 24 6 12 4 9 6 6 7v3l4 1 6 3 10 3 4 6v5l-2-1-2-7-10-2-5-2v-2l-5-1-4-3v-2l-3-1-4-5-5-3h-2v-2l-9-2-21-5-15-3-7-2v-2l-5-1-7-5-17-7-21-4-45-4-23-3-21-5-17-5-9-2-13-3-3-1-40-3h-26l-94-2h-120l-86 2-27 1-29 3-20 3-24 7-25 5-1 1-41 5-23 2-23 4-4 2h-4l-1 3-19 9-12 4-17 3-16 4-10 5-6 5-6 7-6 4-6 2-8 1-4 4-1 3-1 12v34l-2 1 1 38v189h-1l-1-18h-1l-1-39v-48l-1-58-1-12-1-27v-9l-1-4v-12h2l1-5h1l3-36 2-11 1-3 5-3 12-3 7-6 7-8 8-5 12-4 21-5 16-6 12-6h3v-2l17-5 16-3 28-3 18-3 19-4 22-6 9-2 21-4 42-4 28-1 29-1 44-1z'
          fill='#7190B9'
        />
        <path
          transform='translate(1085,857)'
          d='m0 0h1v204l-2 16-3 5-13 6-8 4-3 3h-2v2l-11 8-5 3-16 4-22 5-13 4-22 11-5 2-30 5-21 2-12 1-16 2-21 3-10 3-9 2-10 3-14 4-17 3-26 2-31 1-14 1-46 1h-208l-67-3-3-1-18-2-18-4-9-4-19-4v-2h-8l-10-2-12-1-17-2-37-4-24-5-12-5-13-6-9-3-10-3-14-3-4-2-10-2-9-3-10-5-3-7-6-4-13-4-5-1-3-7-1-3v-17h1l2 19 4 4 5 1 21 9 4 6v2l6 1 12 6 7 1 13 3 7 1 7 2 9 3 9 4 7 4 15 6 11 2 26 3 20 1 42 4 8 1 25 5 12 5 6 4h4v2l16 3 36 3 37 2h156l76-2 41-2 24-2 18-3 5-2 9-4 6-1 2-2 5-2 8-1 9-3 9-1 8-1 30-3 23-1 7-1 20-1 3-1 14-3 14-8 6-4 11-4 5-1 11-3 15-2 7-2 10-3 8-6 11-8 12-6 9-3 5-2 2-28 1-188z'
          fill='#2B4D71'
        />
        <path
          transform='translate(583,23)'
          d='m0 0h62l46 1 94 4 22 1 31 3 31 5 18 5 5 1 19 5 45 7 12 1 19 5 13 6v2l3-1v2l6 2 7 3 22 7 12 3 5 4 5 3 1 3 5 5v2l5 1 5 3 7 2 4 3 5 11 3 18 1 1 1 18v4l-7 2 2-11-1-18-2-5-1-8-4-9-1-3-10-2-10-5-2-5-5-5-8-5-12-4-27-7-7-3v-3l-7-1-7-4-12-5-12-2-25-4-20-2-15-2-18-4-10-2v-2l-8-1-11-3-9-2-23-3-6-1-46-3-25-1-112-2h-84l-87 2-54 2-17 1-11 1-21 3-17 3-9 2-22 6-25 5-12 2-28 3-16 3-14 4h-3v2l-12 5-7 4-19 6-21 5-10 5-8 7-6 7-6 3-11 3-3 1-3 26-1 18-1 7h-2l-2 4-1-3 1-19 2-16 2-11 3-6 4-4 11-4h3v-2h3v-2l3-3 5-6h2l1-3 8-4 16-5 12-3 21-9 10-5 21-6 33-5 11-1 8-2 15-3 17-5 23-5 15-3 26-3 55-3 35-1 47-2z'
          fill='#8DA4C1'
        />
        <path
          transform='translate(230,976)'
          d='m0 0h20l12 3 8 4 6 7 4 11 2 6v25l-5 15-7 10-5 5-5 3-7 2h-26l-10-5-7-7v-2l-3-1-7-8-5-6v-2h-2l-3-6-1-4v-13l6-12 10-13 8-6 9-4zm2 8-7 4-7 7-9 20v9l8 16h2l1 4 7 9 5 3 10 1 12-4 5-4v-2l5-2 7-13 1-4v-12l-2-12-5-9-5-5-14-6z'
          fill='#706F4C'
        />
        <path
          transform='translate(235,649)'
          d='m0 0h12l13 5 7 6 4 8 1 7v14l-3 9-7 8-9 5-10 2h-9l-9-5-1-3h-2l-8-11-5-12v-10l4-8 6-7 8-5z'
          fill='#D4B34E'
        />
        <path
          transform='translate(228,296)'
          d='m0 0h25l13 4 10 9 5 15 1 12-1 17-2 8-6 12-7 8-8 3-6 1h-25l-10-4-9-7-7-8-3-3-4-7-5-10-1-8 2-8 5-9 13-15 8-6 8-3zm11 7-9 1-8 5-8 14-5 11v10l4 9 6 10 4 8 4 3h3v2l7 2 16-3 6-4v-2h2l4-5 6-13 1-7v-11l-2-10-7-11-5-5-9-3z'
          fill='#706F4C'
        />
        <path
          transform='translate(1084,134)'
          d='m0 0h1l1 32 1 1 1 35-1 198-4 4-13 5-8 5v14l1 6 1 4 1 3 3 1 1 5h3v2h2l3 5 5 5 4 9 2 11v28l-1 4 4 1v164l-1 40-2 14-6 14-7 10h-3l-1 4-5 5-3 1-2 6-1 1v9l-2 4 4 2 1 3 18 6 2 3-13-3-11-3-5-3-1-4 4-9v-5h-3v-3l2-1 2-8 4-1v-3l6-5 3-5 4-4 1-2h2v-2l3-3 3-6 1-154v-60l-2-36-3-9-5-5-10-7-4-5-5-15 2-6h-2l-1-8 1-9 5-5 22-8 2-5v-207l-1-22z'
          fill='#3D68A0'
        />
        <path
          transform='translate(550,35)'
          d='m0 0h71l105 1 58 2 14 2 13 3 20 7 7 3 21 4h11l9 2 49 3 10 1 20 4 9 4 10 6 3 1v2l10 2 4 2 16 3h7l4 2 8 1 12 5 10 6 5 5 2 1v2l4 1 6 3 5 2 7 1 3 3-12-2-10-4-11-7v-2l-14-7-16-6-20-2-5-2-10-2-13-6-3-1v-2l-4-1-4-2v-2l-10-2-5-2-23-2-20-1h-19l-2-1-18-1-18-2-6-2-12-2-2-1v-2h-6l-13-6-25-6-26-1-17-1-45-1h-185l-14 1h-29l-44 2-13 2-10 3-11 3-13 5-9 3-17 4-9 1-19 2-26 1-19 1-5 1-19 1-12 4h-2l-1 3-7 5h-2v2l-13 5-5 2-25 3-18 4-5 2-6 4-5 5h-2v2h-2l-1 3h-3l-1 3-6 2h-15l2-2 11-1 6-3 7-6h2l2-4 4-4 11-5 21-4 15-2 15-4 4-1v-2l7-4h2v-2l7-4 13-4 23-2 23-1 13-1 7-1 26-3 5-2 12-2 13-4 5-3 14-3 7-2 21-3 33-1 24-1z'
          fill='#3D68A0'
        />
        <path
          transform='translate(121,405)'
          d='m0 0 3 1 8 1 6 2 1 5-1 1v8l-1 7v3l-3 3-3 8-3 3-1 2h-3l-1 3-6 4-5 7-1 56 1 217h5l2 3 3 1 1-3v3l4 1-3 1v6l6 1 1 3h2l2 5 2-2 2 2v3h3l-1 4-3-1 2 5 2 1-1 3-1-2h-2l-1 7 1 4h-7l1 2 8 1 1 4h-4l-1 2-9 3h-10l5-4 10-3-3-2 1-4h3l-2-5v-6l3-3-7-1-3-4v-2h-2v-2h-7l-1-3h-2l-1-6-1-17h-2l-2-3-1-6 1-23 1-53v-49l-1-19v-105l2-9h2l1-19 1-3 9-5 8-4 2-10h5l-1-8-6-1-2-1v-2l-4-2-5 1-2-1 1-3zm4 2 4 1z'
          fill='#6E8EB7'
        />
        <path
          transform='translate(234,625)'
          d='m0 0h8l10 2 10 5v2l5 2 8 7 7 12 3 11v26l-3 13-5 8-9 10-5 3-4 3-12 5-11 2-13-4-5-3v-2l-3-1-4-5-4-2-3-3-12-9-4-6-4-13v-17l4-10 9-10 6-4 8-8 11-9 7-4zm-4 6-9 6-9 8-4 4-9 7-8 9-2 7v14l3 11 3 5 5 5 6 2v2l5 2v2l4 2 3 3 9 5 13 1 12-2 8-3v-2l4-1 2-1v-2l5-2 4-6 5-10 2-15v-15l-3-10-4-6-10-11-12-6-10-3z'
          fill='#405A6F'
        />
        <path
          transform='translate(1084,816)'
          d='m0 0h1l1 30 1 1 1 35v169l-1 19-3 11-4 4-16 8-10 9-7 5-19 7-21 4-16 6-16 8-15 5-26 4-23 2-24 3-6 2-12 2-11 2-5 2-28 7-20 3-36 2-26 1h-59v-1l46-1 14-1 31-1 26-2 17-3 14-4 10-3 9-2 10-3 21-3 22-3h8l19-2 19-3 13-3 12-5 9-5 13-5 16-4 20-4 10-4 10-8h2v-2l10-7 12-5 4-1 3-9 1-16v-200l-1-10z'
          fill='#3C67A0'
        />
        <path
          transform='translate(1086,122)'
          d='m0 0 3 1 1 8 2 6 1 18-2 9 5-1 1 5v141l-1 32-2 26-1 10-2 18-2 7-6 4-7 1 1-2 8-3 2-7 1-29v-11l1-16v-26l1-62v-83l-3-2v-24l-1-14z'
          fill='#7290B9'
        />
        <path
          transform='translate(232,622)'
          d='m0 0h14l9 2 10 5v2l4 2 7 6 10 16 4 11 1 8v12l-1 11-5 12-6 9-5 4-1 2h-2v2l-10 7-12 6-7 2-13-1-10-4-26-24-5-4-4-8-3-11-1-14 3-10 4-8 3-4h2l1-3 10-6 7-8 14-11zm2 3-9 3-9 7-13 12-9 7-7 9-3 8v17l4 13 5 7 11 8 10 8 2 3h2v2l10 5 9 2 16-4 9-5 3-3 5-3 9-10 4-9 2-10v-26l-4-13-6-10-9-8-4-1-1-3-9-4-12-2z'
          fill='#2A4C72'
        />
        <path
          transform='translate(238,973)'
          d='m0 0 17 1 14 5 7 5 4 6 6 18 1 4v20l-4 12-9 15-8 7-11 4-14 1-15-1-14-5-6-5v-2l-4-2-4-5-3-3v-2h-2l-7-12-2-7v-13l2-8 8-13 12-11 12-6 6-2zm-8 3-13 4-8 5-5 4-11 15-4 9v13l3 8 1 2h2l2 4 9 10 2 3h2l2 4 7 6 8 4h26l9-3 7-5 5-7 5-10 3-10v-25l-5-15-6-8-4-3-12-4-5-1z'
          fill='#405A6F'
        />
        <path
          transform='translate(583,23)'
          d='m0 0h62l46 1 45 2-1 3h-44l-61-1h-78l-87 2-54 2h-3v-2h-13v-1l45-2 78-3z'
          fill='#8EA5C2'
        />
        <path
          transform='translate(227,293)'
          d='m0 0h13l16 1 12 4 8 6 6 12 3 9 2 8v11l-2 10-5 13-5 10-4 5-9 4-9 2h-26l-10-3-11-6-11-11-8-14-3-10v-11l3-8 7-11 9-10 12-8zm1 3-9 3-8 4-7 7-9 11-5 9-2 8 2 10 5 10 6 8 8 9 9 7 9 3h25l12-3 7-6 5-8 4-9 2-18v-11l-4-16-3-6-9-8-13-4z'
          fill='#405A6F'
        />
        <path
          transform='translate(224,972)'
          d='m0 0h19l13 1 16 5 6 5 6 9 5 12 4 11 1 8-2 10-6 12-6 10-6 9-8 5-13 4h-28l-12-3-8-5-8-7-6-8-6-10-4-11v-18l7-15 5-7h2l2-4h2l1-3 16-8zm14 1-14 1-15 6-10 9-6 5-8 14-1 6v13l3 9 6 10h2l1 4 8 8h2v2l8 6 12 4 21 1 12-2 10-5 7-8 7-12 4-12v-20l-2-9-4-10-3-6-5-5-6-4-12-4z'
          fill='#2A4C72'
        />
        <path
          transform='translate(222,292)'
          d='m0 0h25l15 2 12 5 7 8 6 12 1 7h2l4 8v9l-2 10-5 8-1 3h-2l-2 6-5 9-7 7-9 3-18 2h-19l-9-3-9-4-9-7-5-6-8-16-3-10v-15l8-16 7-8 8-7 11-5zm5 1-12 3-12 8-7 7-10 15-2 7v11l3 10 8 14 11 11 16 8 5 1h26l15-4 8-8 4-9 6-15 1-8v-11l-2-10-5-12-6-9-8-5-10-3-16-1z'
          fill='#2A4C72'
        />
        <path
          transform='translate(111,1053)'
          d='m0 0h1l1 22 3 10 10 1 10 4 6 5 1 6 5 2 13 4 5 2 9 2 6 2 11 2 9 3 11 4 16 8 14 4 16 3 40 4 22 3 7 1 15 2v2l10 1 15 4 3 2 24 5 12 1 3 1 67 3v1h-38l-46-3-21-3-9-3-6-1-9-3-26-5h-2v-2h-9l-3-1-12-1-13-2-27-3-22-5-9-3-9-4-12-6-10-3-11-2-4-2-14-2-2-2-9-2-8-4-5-4-6-9-8-2-7-1-5-4v-2h-2l-1-4-1-22z'
          fill='#3D68A0'
        />
        <path
          transform='translate(113,1083)'
          d='m0 0 6 5 13 2 5 4 4 7 5 4 10 4 7 2 4 1 11 2 7 3 10 2 11 3 12 7 11 4 16 4 17 3 30 3 3 1 12 1 12 2 7 2 21 4 11 4 7 1 12 3 26 3 35 2 66 1v1h-83l-24-2-23-2-21-4-7-1-16-4-7-2-16-3-9-2-12-1-2-1-24-3-23-4-20-6-11-5-7-3-4-3-10-2-6-2-14-3-21-7-4-5-3-1-2-4v-3l-7-2-4-2-7-1-4-4z'
          fill='#4F77AD'
        />
        <path
          transform='translate(110,140)'
          d='m0 0h1l1 27-2 1 1 38v189h-1l-1-18h-1l-1-39v-48l-1-58-1-12-1-27v-9l-1-4v-12h2l1-5h1l1-12 1-10z'
          fill='#6F8EB5'
        />
        <path
          transform='translate(1087,511)'
          d='m0 0 4 1v164l-1 40-2 14-6 14-7 10h-3l-1 4-5 5-3 1-2 6-1 1v9l-2 4 4 2 1 3 18 6 2 3-13-3-11-3-5-3-1-4 4-9-1-6 4-2-1-5 6-5 2-3h2l3-6h2l2-4 7-10 3-9 1-169z'
          fill='#4F77AD'
        />
        <path
          transform='translate(1083,798)'
          d='m0 0 2 4 2 12 1 25v7l3 2v172l-1 10v22l-2 23-3 8-6 5-3-1 6-4 3-8 1-5 1-29v-168l-1-26-1-1-1-30z'
          fill='#4F77AD'
        />
        <path
          transform='translate(112,1058)'
          d='m0 0h1l2 19 4 4 5 1 21 9 4 6v2l6 1 12 6 7 1 13 3 7 1 7 2 9 3 9 4 7 4 15 6 10 3 5 2 38 4 5 1-1 2-40-4-24-5-12-5-13-6-9-3-10-3-14-3-4-2-10-2-9-3-10-5-3-7-6-4-13-4-5-1-3-7-1-3z'
          fill='#305071'
        />
        <path
          transform='translate(121,405)'
          d='m0 0 3 1 8 1 6 2 1 5-1 1v8l-1 7v3l-3 3-3 8-3 3-1 2h-3l-1 3-6 4-5 7-2 11-1 1-1 11v18l-2 1v-32l2-9h2l1-19 1-3 9-5 8-4 2-10h5l-1-8-6-1-2-1v-2l-4-2-5 1-2-1 1-3zm4 2 4 1z'
          fill='#7190B9'
        />
        <path
          transform='translate(1085,510)'
          d='m0 0 3 2v59l-1 155-4 11-9 12h-2l-2 4-6 7-4 3v5l-4 3h-2v-3l2-1 2-8 4-1v-3l6-5 3-5 4-4 1-2h2v-2l3-3 3-6 1-154z'
          fill='#3C67A0'
        />
        <path
          transform='translate(1085,514)'
          d='m0 0h1v60l-1 154-5 9h-2v2h-2l-2 5-3 1-2 5-5 5h-2v3l-4 1-1 7-2-1 1-9 7-9h2l1-4h2l2-4 9-8 1-3h2l1-13 1-199z'
          fill='#2E4F71'
        />
        <path
          transform='translate(138,410)'
          d='m0 0 7 1-2 4h-4l1 4 2-2 1 5-4 2-2 21-3 7-2 4-2 2-4 5-10 5-3 4-2 4v-13l6-8 6-4 1-2h3l2-5h2l1-5 3-5 1-1-2-2 2-1 1-9v-6z'
          fill='#4F77AD'
        />
        <path
          transform='translate(1067,408)'
          d='m0 0 3 1-8 5v14l1 6 1 4 1 3 3 1 1 5h3v2h2l3 5 5 5 4 9 2 11v28l-2 4-1-1v-21l-2-18-3-5v-3l-5-2-4-4-6-5-6-12-1-5 1-7-1-8v-5l3-4z'
          fill='#4F77AD'
        />
        <path
          transform='translate(928,1136)'
          d='m0 0h17v1l-14 2-21 2-12 1-16 2-21 3-10 3-9 2-10 3-14 4-17 3-26 2h-20v-1l32-2 15-2 18-4 10-4 11-3 7-2 15-3 44-5 18-1z'
          fill='#405A6F'
        />
        <path
          transform='translate(1084,175)'
          d='m0 0h1l1 14v207l-2 5-10 4-13 5h-2l-2 4-1 16-2 1-1-11 2-9 5-4 23-8 1-7z'
          fill='#2E4F71'
        />
        <path
          transform='translate(111,738)'
          d='m0 0h1l1 8h3v2l5 2 3 6v2l4 2 5 2 4 1 3 5 2 1-1 3-1-2h-2l-1 7 1 4h-7l1 2 8 1 1 4h-4l-1 2-9 3h-10l5-4 10-3-3-2 1-4h3l-2-5v-6l3-3-7-1-3-4v-2h-2v-2h-7l-1-3h-2l-1-6z'
          fill='#7693BA'
        />
        <path
          transform='translate(1095,874)'
          d='m0 0 2 4v153l-2 19-2-2v-12l1-15v-144z'
          fill='#8AA2C0'
        />
        <path
          transform='translate(504,1167)'
          d='m0 0h162l-1 2-10 1h-26l-6 1h-10l-8-1-15 1-5-1-18-1-63-1z'
          fill='#446DA5'
        />
        <path
          transform='translate(1095,541)'
          d='m0 0h1l1 20-1 21 1 29v38l-1 53-1 9h-2v-16l1-14v-137z'
          fill='#8AA2C0'
        />
        <path
          transform='translate(1095,172)'
          d='m0 0 2 2v135l-1 32-1 13-2-2v-15l1-16v-147z'
          fill='#8AA2C0'
        />
        <path
          transform='translate(1067,431)'
          d='m0 0 3 1 3 4 5 3 1 3h3l1 3 2 1 8 24 3 20v22h-1v-8h-2v3h-2v-27l-5-19-4-10-4-6-6-4-5-5-1-3z'
          fill='#8DA4C1'
        />
        <path
          transform='translate(111,726)'
          d='m0 0h1v10h5l2 3 3 1 1-3v3l4 1-3 1v6l6 1 1 3h2l2 5 2-2 2 2v3h3l-1 4-3-1-1 3v-3h-6l-7-5-4-8-4-2v-2l-3 1-1-1-1-8z'
          fill='#3E69A1'
        />
        <path
          transform='translate(1066,771)'
          d='m0 0 2 2v10l4 1 9 6 5 5 3 4 3 8 3 15 2 16v9l-2-2h-5l1-5v-16l-1-13-3-9-4-7-1-3-8-1-4-4-5-3-1-6v-5z'
          fill='#8DA4C2'
        />
        <path
          transform='translate(300,1140)'
          d='m0 0 16 1 8 1 14 2 9 1 5 1 4 2 7 2 14 5h3v2l10 1 4 3-9-1-15-3-9-4-19-4v-2h-8l-10-2-12-1-13-2z'
          fill='#405A6F'
        />
        <path
          transform='translate(107,655)'
          d='m0 0h1l1 27h1l1 30v17l-1 2h-2l-2-3-1-6 1-23z'
          fill='#7190B9'
        />
        <path
          transform='translate(1084,720)'
          d='m0 0h1v8l-5 9h-2v2h-2l-2 5-3 1-2 5-5 5h-2v3l-4 1-1 7-2-1 1-9 7-9h2l1-4h2l2-4 9-8 1-3 3-2z'
          fill='#2C4D71'
        />
        <path
          transform='translate(487,25)'
          d='m0 0 1 2-18 1-5 2-54 2h-3v-2h-13v-1l45-2z'
          fill='#8EA5C2'
        />
        <path
          transform='translate(113,793)'
          d='m0 0h4v2l-4 1-1 12-1 2h-2v28l1 7h-4l1 14-2 2-1-28 3-26 2-8h2z'
          fill='#8FA6C3'
        />
        <path
          transform='translate(738,1162)'
          d='m0 0m-2 0 2 2-45 2-9 1h-68v-1l60-2 40-1z'
          fill='#315170'
        />
        <path
          transform='translate(502,1172)'
          d='m0 0h27l5 2 1-2 14 1 2 1 15-1 5 1 7-1 6 1 7-1v2h7l-1 2-9-1-5 1-27-1h-27l-5-1-22-2z'
          fill='#8AA2C0'
        />
        <path
          transform='translate(112,732)'
          d='m0 0 11 1 3 3v2l5 5 3 8h3l3 6-3-1-2 2-2-3v-3h-2l-3-3-5-1v-6-2l-5-1-1-2-5-1z'
          fill='#2E4F71'
        />
        <path
          transform='translate(115,742)'
          d='m0 0 7 3 2 7 3-1 3 4 1 4 5-1 1-3 2 2v3h3l-1 4-3-1-1 3v-3h-6l-7-5-4-8-4-2v-2l-3 1-1-4z'
          fill='#4B73A7'
        />
        <path
          transform='translate(131,769)'
          d='m0 0 1 3h3l1-2 1 7 1 4h-7l1 2 8 1 1 4h-4l-1 2-9 3h-10l5-4 10-3-3-2 1-4h3l-2-5z'
          fill='#809BBD'
        />
        <path
          transform='translate(1e3 1113)'
          d='m0 0h9v1l-20 5-13 6-14 7-5 2-11 2h-5l3-2 13-3 9-4 8-5 7-3 15-5z'
          fill='#405A6F'
        />
        <path
          transform='translate(130,431)'
          d='m0 0 2 1-1 5-8 6h-2v2l-5 2-2 3h-2l-1 3v-8l1-3 9-5 8-4z'
          fill='#8DA4C1'
        />
        <path
          transform='translate(136,440)'
          d='m0 0h1v5l-3 7-2 4-2 2-4 5-10 5-4 4 1-4 1-3h2l1-3 8-4 3-4h2l3-9z'
          fill='#3D68A0'
        />
        <path
          transform='translate(1085,391)'
          d='m0 0h1l-1 9-5 3-19 7h-2l-2 4-1 16-2 1-1-11 2-9 5-4 23-8 1-7z'
          fill='#335270'
        />
        <path
          transform='translate(110,457)'
          d='m0 0h1v12l-2 6-1 11v18l-2 1v-32l2-9h2z'
          fill='#8BA2C0'
        />
        <path
          transform='translate(110,167)'
          d='m0 0h2v62h-1l-2-61z'
          fill='#436DA4'
        />
        <path
          transform='translate(111,1053)'
          d='m0 0h1l1 22 3 10 10 1 6 3v1l-13-1-5-4v-2h-2l-1-4-1-22z'
          fill='#3D68A0'
        />
        <path
          transform='translate(122,757)'
          d='m0 0 5 2 4 3 6 1 3 5 2 1-1 3-1-2h-2l-1 5-2-3h-3l1-5 1-1-7-1-3-4v-2h-2z'
          fill='#7593BA'
        />
        <path
          transform='translate(111,808)'
          d='m0 0h1v13l-1 23-2-2-1-6v-11l1-15h2z'
          fill='#6B8CB7'
        />
        <path
          transform='translate(622,1167)'
          d='m0 0h44l-1 2-10 1h-14v-2h-19z'
          fill='#456EA5'
        />
        <path
          transform='translate(107,655)'
          d='m0 0h1l1 27h1v17h-3z'
          fill='#829CBD'
        />
        <path
          transform='translate(202,1118)'
          d='m0 0 7 1 9 4 9 5 10 3 1 2-7-1-9-4-13-6-7-3z'
          fill='#405A6F'
        />
        <path
          transform='translate(104,187)'
          d='m0 0 2 2 1 26 1 13-2 4-1-12-1-27z'
          fill='#8AA2C0'
        />
        <path
          transform='translate(138,410)'
          d='m0 0 7 1-2 4h-4l1 4 2-2 1 5-4 2-1 8h-1v-17z'
          fill='#4971A7'
        />
        <path
          transform='translate(616,1167)'
          d='m0 0 25 1-1 2h-11l-6 1h-10l-5-1v-2z'
          fill='#4F77AD'
        />
        <path
          transform='translate(106,699)'
          d='m0 0 2 4v19l3 2-1 7h-2l-2-3-1-6z'
          fill='#8AA2C0'
        />
        <path
          transform='translate(1043,1102)'
          d='m0 0 4 1-8 5-16 4-10 1 4-2 12-3 9-3z'
          fill='#405A6F'
        />
        <path
          transform='translate(122,748)'
          d='m0 0h6l3 2v2h2l2 6-4 2-4-8-3 2z'
          fill='#3D68A0'
        />
        <path
          transform='translate(113,793)'
          d='m0 0h4v2l-4 1-1 12-1 2-4 1 1-10 1-2h2z'
          fill='#7F9ABD'
        />
        <path
          transform='translate(123,742)'
          d='m0 0 3 4h2v-2h2l2 5 3 2h2l3 6-3-1-2 2-2-3v-3h-2l-3-3-5-1z'
          fill='#405A6F'
        />
        <path
          transform='translate(1081,732)'
          d='m0 0 1 2-2 3h-2v2h-2l-2 5-3 1-2 5-5 5h-2v3l-4 1 3-5h2l1-3 5-5 8-10z'
          fill='#405A6F'
        />
        <path
          transform='translate(139,777)'
          d='m0 0 4 4 1 4-3 3-1-3-8-1-1-3h7z'
          fill='#406BA6'
        />
        <path
          transform='translate(112,732)'
          d='m0 0 11 1-1 7-4-1-1-2-5-1z'
          fill='#315070'
        />
        <path
          transform='translate(1085,391)'
          d='m0 0h1l-1 9-5 3-11 4h-6l3-2 17-6 1-7z'
          fill='#315070'
        />
        <path
          transform='translate(115,742)'
          d='m0 0 7 3 2 9-6-5-2-1v-2l-3 1-1-4z'
          fill='#4F77AD'
        />
        <path
          transform='translate(110,457)'
          d='m0 0h1v12l-4 12h-1v-8l2-9h2z'
          fill='#8FA6C3'
        />
        <path
          transform='translate(121,405)'
          d='m0 0 3 1h5l-1 6 4 2-5-1v-2l-4-2-5 1-2-1 1-3z'
          fill='#859EBE'
        />
        <path
          transform='translate(1084,1049)'
          d='m0 0h1l1 12-1 12h-1l-1-5v-18z'
          fill='#315071'
        />
        <path
          transform='translate(111,1053)'
          d='m0 0h1l1 22 1 7-2 1-1-4-1-22z'
          fill='#436DA4'
        />
        <path
          transform='translate(175,1111)'
          d='m0 0 8 1 11 2 3 2 5 1-2 2-10-3-14-3z'
          fill='#405A6F'
        />
        <path
          transform='translate(487,25)'
          d='m0 0 1 2-18 1-5 2-6-1 2-2z'
          fill='#92A8C4'
        />
        <path
          transform='translate(1e3 1127)'
          d='m0 0 2 1-9 6-10 4-4-1 16-7h2v-2z'
          fill='#8AA2C0'
        />
        <path
          transform='translate(107,837)'
          d='m0 0 2 1 1 7h-4l1 14-2 2v-18h2l-1-5z'
          fill='#89A1BF'
        />
        <path
          transform='translate(1080,1080)'
          d='m0 0 1 2-13 6-6 3-2-1 5-4z'
          fill='#405A6F'
        />
        <path
          transform='translate(1085,396)'
          d='m0 0h2l-1 6-5 3-5 2-4-1h2v-2l10-4z'
          fill='#4770A7'
        />
        <path
          transform='translate(1095,514)'
          d='m0 0h1l1 9-1 17-2-3v-20z'
          fill='#8AA2C0'
        />
        <path
          transform='translate(111,1083)'
          d='m0 0h2l1 3 3 2v2l4 1 3 2h-6l-5-4z'
          fill='#7995BB'
        />
        <path
          transform='translate(143,420)'
          d='m0 0 1 3-2 8h-4l1-7z'
          fill='#365470'
        />
        <path
          transform='translate(141,417)'
          d='m0 0 2 3-2 4h-2l-1 8h-1v-9l1-4h2z'
          fill='#406AA2'
        />
        <path
          transform='translate(1078,406)'
          d='m0 0 4 1-6 3-5 1-1 5-2 3h-2l2-6 2-3 5-2z'
          fill='#8AA2C0'
        />
        <path
          transform='translate(1057,790)'
          d='m0 0 20 6v1l-10-1-10-4z'
          fill='#3D68A0'
        />
        <path
          transform='translate(132,768)'
          d='m0 0h8l2 1-1 3-1-2h-2l-1 5-2-3h-3z'
          fill='#5077AD'
        />
        <path
          transform='translate(115,109)'
          d='m0 0 2 1-2 3h-2l-1 6-4 3 1-5 3-5z'
          fill='#91A7C4'
        />
        <path
          transform='translate(109,335)'
          d='m0 0h1v15h-2l-1-12z'
          fill='#7D99BC'
        />
        <path
          transform='translate(1087,800)'
          d='m0 0h2l3 7v4h-2l-3-9z'
          fill='#8CA3C1'
        />
        <path
          transform='translate(122,789)'
          d='m0 0 5 1 2 2-2 1h-10z'
          fill='#6B8BB6'
        />
        <path
          transform='translate(133,751)'
          d='m0 0h4l3 6-3-1-2 2-2-3z'
          fill='#2F4F71'
        />
        <path transform='translate(108,732)' d='m0 0' fill='#8AA2C0' />
        <path transform='translate(108,379)' d='m0 0' fill='#8AA2C0' />
        <path transform='translate(108,385)' d='m0 0' fill='#8AA2C0' />
      </svg>
    </div>
  )
}

export default DatabaseIcon
